import { Injectable } from "@angular/core";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { StoreService } from "@root/shared/service/store.service";
import { HouseOrderDetailComponent } from "@root/router/component/house-order-detail/house-order-detail.component";
import { SyncTasksSubListComponent } from "@root/router/component/jobs/syn-task-list/syn-task-list.component";
import { TujiaAutoReceiptComponent, key } from "@root/component/tujia-auto-receipt/tujia-auto-receipt.component";
import { InviteComponent } from "@root/component/invite/invite.component";
import { ImageMagnifierService } from "@root/component/image-magnifier/image-magnifier.service";
import { ClientComponent } from "../component/customer-service/client/client.component";
// import {
//   ZhenguoSyncMessageComponent,
//   key as zhenguoKey,
// } from "@root/component/zhenguo-sync-message/zhenguo-sync-message.component";
import { TranslateService } from "@root/shared/service/translate.service";
import { QrcodeDownloadComponent } from "@root/component/qrcode-download/qrcode-download.component";
import { CouponListComponent } from "@root/component/coupon-list/coupon-list.component";
import { SystemNotificationComponent } from "@root/component/system-notification/system-notification.component";
import { AuditDetailsComponent } from "@root/router/component/property/audit-details/audit-details.component";
import { FailHousesComponent } from "@root/router/component/property/fail-houses/fail-houses.component";
import { DuplicateGuestComponent } from "../component/guest/duplicate-guest/duplicate-guest.component";
import { EditGuestComponent } from "../component/guest/edit-guest/edit-guest.component";
import { EditRateComponent } from "@root/router/component/rate/edit-rate/edit-rate.component";
import { CreateTaskComponent } from "@root/router/component/task/create-task/create-task.component";
import { DepositComponent } from "../component/deposit/deposit.component";
import { NzDrawerRef, NzDrawerService } from "ng-zorro-antd/drawer";
import { PropertyDetailComponent } from "../component/property/property-detail/property-detail.component";
import { RoomTypeDetailComponent } from "../component/property/room-type-detail/room-type-detail.component";
import { AppService } from "@root/app.service";
import { V4HousesModalSelectComponent } from "../component/v4/houses-modal-select/houses-modal-select.component";
import { PropertyCalendarComponent } from "../component/property/property-calendar/property-calendar.component";
import { RoomTypeCalendarComponent } from "../component/property/room-type-calendar/room-type-calendar.component";
import { HostexSidebarComponent } from "../component/operate-sidebar/hostex-sidebar/hostex-sidebar.component";
import { ChannelSidebarComponent } from "../component/operate-sidebar/channel-sidebar/channel-sidebar.component";
import { HourReservationSidebarComponent } from "../component/operate-sidebar/hour-reservation-sidebar/hour-reservation-sidebar.component";
import { TaskDetailComponent } from "../component/task/task-detail/task-detail.component";
import { BsListingsDetailComponent } from "../component/property/bs-listings-detail/bs-listings-detail.component";
@Injectable({
  providedIn: "root",
})
export class ModalService {
  private customerServiceClientRef: NzModalRef;
  private notificationRef: NzModalRef;

  get isInternational() {
    return this.app.app.international;
  }

  constructor(
    private modalService: NzModalService,
    private drawer: NzDrawerService,
    private storeService: StoreService,
    private imageMagnifierService: ImageMagnifierService,
    private t: TranslateService,
    private app: AppService,
  ) {}

  displayReservationDetail(params) {
    this.modalService.create({
      // 订单详情
      // nzTitle: this.t.syncGet("word.order_detail"),
      nzContent: HouseOrderDetailComponent,
      nzFooter: null,
      nzWidth: 1000,
      nzComponentParams: {
        pageType: "modal",
        ...params,
      },
    });
  }

  displayTaskList(params) {
    this.modalService.create({
      // 同步任务列表
      nzTitle: this.t.t("index.sync_task_list"),
      nzContent: SyncTasksSubListComponent,
      nzWidth: 690,
      nzFooter: null,
      nzComponentParams: params,
    });
  }

  displayAuditDetail(params) {
    const modal = this.modalService.create({
      // 审核详情
      nzTitle: this.t.t("house.airbnb_check_detail"),
      nzContent: AuditDetailsComponent,
      nzFooter: null,
      nzWidth: "653px",
      nzComponentParams: params,
    });
    modal.afterClose.subscribe((res) => {
      if (res === "openFailList") {
        this.displayAuditFailedHouseList();
      }
    });
  }

  displayAuditFailedHouseList() {
    const modal = this.modalService.create({
      // 爱彼迎直连审核失败房源
      nzTitle: this.t.t("house.airbnb_fail_list"),
      nzContent: FailHousesComponent,
      nzFooter: null,
      nzWidth: "653px",
    });
    modal.afterClose.subscribe((res) => {
      if (res && res.title === "openAuditDetail") {
        this.displayAuditDetail({ code: res.house.origin_house_id });
      }
    });
  }

  displayTujiaAutoReceiptModal(code?: string) {
    const tujiaReservationPrefix = "1-";

    if (code && !code.startsWith(tujiaReservationPrefix)) {
      return;
    }

    const forbideAlert = !!this.storeService.get(key, 2);
    if (forbideAlert) {
      return;
    }

    this.modalService.create({
      nzTitle: null,
      nzContent: TujiaAutoReceiptComponent,
      nzFooter: null,
      nzWidth: 420,
      nzClosable: false,
    });
  }

  // displayZhenguoSyncMessageModal() {
  //   const forbideAlert = !!this.storeService.get(zhenguoKey, 2);
  //   if (forbideAlert) {
  //     return;
  //   }
  //   this.modalService.create({
  //     nzTitle: null,
  //     nzContent: ZhenguoSyncMessageComponent,
  //     nzFooter: null,
  //     nzWidth: 420,
  //     nzClosable: false,
  //   });
  // }

  displayInviteModal() {
    this.modalService.create({
      nzTitle: "我的邀请",
      nzContent: InviteComponent,
      nzFooter: null,
      nzWidth: 580,
    });
  }

  // displayCustomerServiceModal() {
  //   this.modalService.create({
  //     nzTitle: null,
  //     nzContent: CustomerServiceComponent,
  //     nzWidth: 380,
  //     nzFooter: null,
  //     nzWrapClassName: 'host-pay-invite-service-modal',
  //   });
  // }

  /**
   * @deprecated
   *
   * 使用组件打开的方式将被废弃，替换为指令的方式 img-preview
   */
  displayImageMagnifier(url) {
    this.imageMagnifierService.open(url);
  }

  displayAppDownloadModal() {
    this.modalService.create({
      nzTitle: null,
      nzContent: QrcodeDownloadComponent,
      nzWidth: 335,
      nzFooter: null,
      nzClosable: false,
      nzBodyStyle: {
        padding: "0",
      },
    });
  }

  displayCouponListModal(params?) {
    return this.modalService.create({
      nzTitle: this.t.t("modal.coupon.list.title"),
      nzContent: CouponListComponent,
      nzFooter: null,
      nzWidth: 480,
      nzBodyStyle: {
        padding: "0",
      },
      nzComponentParams: params,
    });
  }

  displaySystemNotificationModal(data: any) {
    if (this.notificationRef) {
      return;
    }

    const position: "center" | "right_bottom" = data.position;

    const style = position === "center" ? {} : { bottom: "20px", right: "20px", top: "auto", position: "absolute" };
    const hasIcon = position === "center" ? true : false;
    this.notificationRef = this.modalService.create({
      nzTitle: null,
      nzContent: SystemNotificationComponent,
      nzFooter: null,
      nzWrapClassName: "just-test",
      nzBodyStyle: {
        padding: "0",
      },
      nzStyle: style,
      nzComponentParams: { notification: { ...data, has_icon: hasIcon } },
    });

    this.notificationRef.afterClose.subscribe((res) => (this.notificationRef = null));
  }

  displayCustomerServiceClient(params?) {
    if (this.isInternational) {
      return this.displayLiveChatClient();
    } else {
      return this.displayCSClient(params);
    }
  }

  private displayCSClient(params?) {
    if (this.customerServiceClientRef) {
      return this.customerServiceClientRef;
    }
    this.customerServiceClientRef = this.modalService.create({
      nzTitle: null,
      nzContent: ClientComponent,
      nzWidth: 400,
      nzFooter: null,
      nzMask: true,
      nzMaskClosable: false,
      nzClosable: false,
      nzWrapClassName: "host-customer-service-client-modal",
      nzComponentParams: { entry: "web-客服", ...params },
    });
    this.customerServiceClientRef.afterClose.subscribe((res) => {
      this.customerServiceClientRef = null;
    });

    return this.customerServiceClientRef;
  }

  private displayLiveChatClient() {
    return window["$chatwoot"]?.toggle("open");
  }

  isCustomerServiceClientOpen() {
    return !!this.customerServiceClientRef;
  }

  displayChangeHouseModal(resvCode) {
    return this.modalService.create({
      nzTitle: this.t.t("order.change_to_house"),
      nzContent: V4HousesModalSelectComponent,
      nzFooter: null,
      nzWidth: "936px",
      nzComponentParams: {
        mode: "single",
        params: {
          reservation_code: resvCode,
          type: "change_house",
        },
      },
    });
  }

  displayDuplicateGuestModal(params?) {
    return this.modalService.create({
      // nzTitle: '添加房客',
      nzTitle: this.t.t("modal.title.add_guest"),
      nzWidth: 820,
      nzContent: DuplicateGuestComponent,
      nzComponentParams: params,
      nzFooter: null,
    });
  }

  displayCreateGuestModal(guestInfo?) {
    return this.modalService.create({
      // nzTitle: '添加新房客',
      nzTitle: this.t.t("modal.title.add_new_guest"),
      nzWidth: 800,
      nzContent: EditGuestComponent,
      nzComponentParams: { type: "create", guestInfo },
      nzFooter: null,
    });
  }

  displayUpdateGuestModal(guestInfo?) {
    return this.modalService.create({
      // nzTitle: '编辑房客',
      nzTitle: this.t.t("modal.title.edit_guest"),
      nzWidth: 800,
      nzStyle: { top: "50px" },
      nzContent: EditGuestComponent,
      nzComponentParams: { type: "update", guestInfo },
      nzFooter: null,
    });
  }

  displayRateModal(params?) {
    return this.modalService.create({
      nzTitle: this.t.t("rate.word.rate"),
      nzWidth: 680,
      nzContent: EditRateComponent,
      nzFooter: null,
      nzComponentParams: params,
    });
  }

  displayRateReplyModal(params?) {
    return this.modalService.create({
      nzTitle: this.t.t("rate.word.reply"),
      nzWidth: 680,
      nzContent: EditRateComponent,
      nzFooter: null,
      nzComponentParams: {
        pageType: "reply",
        ...params,
      },
    });
  }

  displayCreateTaskModal(data?: any) {
    const titleKey = data?.id ? "task.clean.modify_task" : "task.clean.create_task";
    return this.modalService.create({
      nzTitle: this.t.syncGet(titleKey),
      nzWidth: 700,
      nzContent: CreateTaskComponent,
      nzFooter: null,
      nzComponentParams: {
        data: data,
      },
    });
  }

  displayDepositModal() {
    return this.modalService.create({
      nzTitle: this.t.t("reservation.detail.deposit.item.title"),
      nzWidth: 850,
      nzContent: DepositComponent,
      nzFooter: null,
    });
  }

  // displayChannelPriceRatioModal() {
  //   return this.modalService.create({
  //     // nzTitle: '渠道差价',
  //     nzTitle: this.t.t("modal.channel_diff_price.title"),
  //     nzWidth: 400,
  //     nzContent: ChannelPriceRatioComponent,
  //     nzFooter: null,
  //   });
  // }

  displayPropertyDetailDrawer(id: number, tab = 0, appendPageData?: any) {
    return this.drawer.create({
      nzContent: PropertyDetailComponent,
      nzWidth: 700,
      nzMask: false,
      nzClosable: false,
      nzZIndex: 999,
      nzContentParams: {
        id,
        tab,
        appendPageData,
      },
    });
  }

  displayRoomTypeDetailDrawer(id: number, tab = 0, appendPageData?: any) {
    return this.drawer.create({
      nzContent: RoomTypeDetailComponent,
      nzWidth: 700,
      nzMask: false,
      nzZIndex: 999,
      nzClosable: false,
      nzContentParams: {
        id,
        tab,
        appendPageData,
      },
    });
  }

  displayPropertyCalendarDrawer(id: number) {
    return this.drawer.create({
      nzContent: PropertyCalendarComponent,
      nzWidth: 1200,
      nzMask: false,
      nzContentParams: {
        id,
      },
    });
  }

  displayRoomTypeCalendarDrawer(id: number) {
    return this.drawer.create({
      nzContent: RoomTypeCalendarComponent,
      nzWidth: 1200,
      nzMask: false,
      nzContentParams: {
        id,
      },
    });
  }

  displayBsListingsDetailDrawer(params: {
    listingId: string;
    thirdpartyAccountId: number;
    type: "self_hosted" | "hostex";
  }) {
    return this.drawer.create({
      nzContent: BsListingsDetailComponent,
      nzWidth: 700,
      nzMask: false,
      nzClosable: false,
      nzContentParams: params,
    });
  }

  displayHostexSidebar(params?: any) {
    return this.drawer.create({
      nzTitle: null,
      nzContent: HostexSidebarComponent,
      nzWidth: 490,
      nzMask: false,
      nzClosable: false,
      nzCloseOnNavigation: true,
      nzContentParams: params,
    });
  }

  displayChannelSidebar(params?: any) {
    return this.drawer.create({
      nzTitle: null,
      nzContent: ChannelSidebarComponent,
      nzWidth: 490,
      nzClosable: false,
      nzMask: false,
      nzContentParams: params,
    });
  }

  displayHourResvSidebar(params?: any) {
    return this.drawer.create({
      nzTitle: null,
      nzContent: HourReservationSidebarComponent,
      nzClosable: false,
      nzWidth: 490,
      nzMask: false,
      nzContentParams: params,
    });
  }

  /**
   * 如果有 drawerRef，则代表重用该 ref，而不是新建一个
   */
  displayResvDetailDrawer(code: string, drawerRef?: NzDrawerRef) {
    if (drawerRef) {
      const ins = drawerRef.getContentComponent();
      console.log("get instance: ", ins);
      if (ins) {
        ins.code = code;
        return drawerRef;
      } else {
        return this.displayResvDetailDrawer(code);
      }
    } else {
      return this.drawer.create({
        nzTitle: null,
        nzContent: HouseOrderDetailComponent,
        nzMask: false,
        nzWidth: 520,
        nzClosable: false,
        nzBodyStyle: {
          paddingBottom: 0,
        },
        nzContentParams: {
          code,
        },
      });
    }
  }

  displayTaskDetailDrawer(title, params, drawerRef?: NzDrawerRef) {
    if (drawerRef) {
      const ins = drawerRef.getContentComponent();
      if (ins) {
        Object.assign(ins, params);
        ins.triggerNgOnChanges();
        return drawerRef;
      } else {
        return this.displayTaskDetailDrawer(title, params);
      }
    } else {
      return this.drawer.create({
        nzTitle: title,
        nzContent: TaskDetailComponent,
        nzWidth: 500,
        nzMask: false,
        nzMaskClosable: false,
        nzClosable: false,
        nzContentParams: params,
      });
    }
  }

  destroy() {
    this.customerServiceClientRef && this.customerServiceClientRef.destroy();
    this.customerServiceClientRef && this.customerServiceClientRef.destroy();
  }
}
